import { apiClient } from "@nabble/sdk";

export function changePassword(currentPassword: string, newPassword: string): Promise<{ otherSessionsEnded: boolean }> {
  return apiClient<{ otherSessionsEnded: boolean }>("/api/account/password", {
    method: "POST",
    body: { currentPassword, newPassword },
  });
}

/** Emails a one-time link (valid 1 hour) to the primary email to set a new password. */
export function requestPasswordReset(): Promise<void> {
  return apiClient<void>("/api/account/password-reset", { method: "POST" });
}
